<template>






    <div class="column_box">
        <img src="@/assets/whats_mik.svg" class="img_photos">

        <div class="about_content">


            MIKは、北海道札幌市を拠点に、 <br>札幌、盛岡、大阪、東京、福岡の5つの都市で、<br>主にIT関連企業向けに個性豊かなエンジニア人材を提供する
            <br>成長途上の人材ソリューションサービス企業です。<br>

            <img src="@/assets/chizu.svg" class="img_photos" alt="">
            <br>
            近年では、IT企業以外の土木、建築、移動体通信の分野でも<br>幅広く人材の提供を行っています。
            <br>
        </div>

        <h4>【MIKの特徴1】 未経験者から最速で経験者になれるルートを持っていること。</h4>

        未経験者が入社する際は、<br>必ず配属前の就業前研修（約1〜2ヶ月）を実施します。<br>
        ここでしっかりと基礎を学び、<br>MIKメンバーで組織された3人〜5人程度のチームに配属され、<br>
        現場でのスキルを学びます。<br>
        同業他社と比較しても、1~2ヶ月という期間でエンジニアになれる会社はそう多くありません。
        <br>

        就業前研修と、配属されてからのOJTで弊社社員たちはメキメキと成長していきます。
        <br>
        この流れで、これまでに10名以上の全くの未経験だった方々が現場経験を積んで『経験者』となり<br>活躍の幅を広げています。


        <img src="@/assets/photos.svg" alt="" class="img_photos">
        <br>
        <br>
        <br>
        <br>
        <h4>【MIKの特徴2】 経営陣と、社員の距離が近いこと。</h4>
        <br>
        まだまだ総社員100名以下の小さな会社だからこそ<br>
        経営陣と社員が対等に向き合い<br>「会社を一緒に創っていこう！！」<br>
        という絆が生まれています。

        <br>
        <br>
        <h4>【MIKの特徴3】女性に優しい</h4>

        さらに、この業界では珍しく女性が約4分の1を占めています。<br>

        <br>弊社では、人生の大事なイベントである妊娠・出産・子育てを中心に、<br>キャリアをバランスよく築いていくことが、
        <br>社員の幸せにつながると考えています。

        <br>
        <br>産休中でも、学ぶ機会は通常勤務の社員の方々と同じようにあり、<br>
        お休みも、社内Webアプリから簡単に取得できますので、<br>休みや早退をすることに引け目を感じる必要もありません。<br>
        <br>産休後も、時短勤務や、<br>在宅勤務から始められる配属先を希望することもできます。
        <br>
        <img src="@/assets/ladys.svg" class="img_photos" alt="">

        <h4>【MIKの特徴4】外国籍の方も活躍中</h4>
        外国籍の方も各地域に在籍しています。<br>
        ビザの申請など、<br>外国籍ならではの手続きは、弊社スタッフも手慣れておりますので、<br>
        安心してお仕事に集中していただけます。 <br>
        <br>「外国籍だと、配属先が見つからない」とか、<br>「外国籍」というだけで弾かれてしまう、<br>
        というお声を、残念ながら昨今よく耳にしますが、<br>
        弊社は外国籍であることをマイナス要素と捉えず、
        <br>一人一人にあった配属先を提供しています。
        <br>
        <img src="@/assets/foreigners.svg" class="img_photos" alt="">
        <h4>【MIKの特徴5】独自制度の『社内貢献ポイント』制度</h4>
        MIKでは皆勤賞や、社内イベントの参加賞として、 <br>社内ポイントを発行しています。
        ポイントが貯まると、 <br>ご希望のタイミングで換金して受け取ることができます。
        <br>
        <img src="@/assets/points.svg" class="img_photos" alt="">
        <br><br>
        <h4>
            弊社は、人種、信条、性別の垣根を超えて<br>社員一人一人を<br>大切なエンジニア人材として扱う土壌が整っています。
            <br>しかし、まだまだメンバーが足りません。<br>
            <br>
            もっともっとエンジニアが働きやすい社会を、<br>一緒に創っていきませんか。
        </h4>

        <div class="item_box_wrapper">
            <div class="item_title">
                <h2>【MIKの特徴】</h2>
            </div>
            <div class="item_box">

                <div>
                    <div class="item_mini">
                        <h4>配属までの<br>期間が短い</h4>
                    </div>
                    <div class="item_mini">
                        <h4>経営陣と<br>距離が近い</h4>
                    </div>
                </div>
                <div>
                    <div class="item_mini">
                        <h4>女性に優しい</h4>
                    </div>
                    <div class="item_mini">
                        <h4>外国籍の方も<br>活躍中</h4>
                    </div>
                </div>
                <div>
                    <div class="item_mini">
                        <h4>社内貢献ポイント</h4>
                    </div>
                </div>


            </div>
        </div>
    </div>



</template>
<script>
export default {

}
</script>
<style>
.item_box_wrapper {
    margin-top: 150px;
}

.item_box {
    margin-top: 20px;
}

.img_photos {
    width: 500px;
}

.item_title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.about_content {
    width: 100%;

}

.column_box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

.item_mini {

    font-size: 16px;
    width: 100px;
    height: 80px;
    background-color: #7ed957;
    color: white;
    border-radius: 10px;
    padding: 20px;
    margin: 10px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

@media(max-width:500px) {
    .img_photos {
        width: 300px;
    }


}
</style>